// @flow
import React from "react";
import fillArray from "@justpark/helpers/src/fillArray/fillArray";

import styles from "./paginationDots.module.scss";

type Props = {
  count: number,
  active: number,
  theme?: "default" | "brand",
  size?: "small" | "large",
  onClick?: null | ((number) => void),
  equalSizes: boolean
};

type DotProps = {
  isActive: boolean,
  theme: "default" | "brand",
  size: "small" | "large",
  index: number,
  onClick: null | ((number) => void),
  equalSizes: boolean
};

const Dot = ({
  isActive,
  theme,
  size,
  onClick,
  index,
  equalSizes
}: DotProps) => {
  const clickable = onClick !== null;

  const activeClass = isActive ? styles.activeDot : styles.dot;
  const themeClass =
    theme === "brand" ? styles.brandTheme : styles.defaultTheme;
  const sizeClass = size === "small" ? styles.sizeSmall : styles.sizeLarge;
  const equalSizesClass = equalSizes ? styles.equalSizes : "";

  const item = (
    <div
      className={`${activeClass} ${themeClass} ${sizeClass} ${equalSizesClass}`}
    />
  );

  return clickable ? (
    <button
      type="button"
      onClick={() => {
        onClick(index);
      }}
      className={styles.button}
    >
      {item}
    </button>
  ) : (
    <div className={styles.itemWrapper}>{item}</div>
  );
};

const PaginationDots = ({
  count,
  active,
  theme = "default",
  size = "small",
  onClick = null,
  equalSizes = false
}: Props) => {
  const sizeClass = size === "small" ? styles.sizeSmall : styles.sizeLarge;

  return (
    <div className={`${styles.container} ${sizeClass}`}>
      {fillArray(count, (index) => (
        <Dot
          key={index}
          index={index}
          isActive={index === active}
          theme={theme}
          size={size}
          onClick={onClick}
          equalSizes={equalSizes}
        />
      ))}
    </div>
  );
};

export default PaginationDots;
